"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _constants = require("../constants");
var _Space = _interopRequireDefault(require("./Space.style"));
const _excluded = ["className", "size", "left", "right", "top", "bottom", "fullWidth", "fullHeight", "classes", "children", "forwardRef", "dataTestId"];
const StyledSpace = (0, _reactJss.default)(_Space.default)(_ref => {
  let {
      className,
      size,
      left,
      right,
      top,
      bottom,
      fullWidth,
      fullHeight,
      classes,
      children,
      forwardRef,
      dataTestId
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // If not passed any side - it means all sides are enabled
  const allSidesEnabled = [left, right, top, bottom].every(value => !value);
  const paddingClassName = (0, _clsx.default)(classes[size], {
    left: left || allSidesEnabled,
    right: right || allSidesEnabled,
    top: top || allSidesEnabled,
    bottom: bottom || allSidesEnabled
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _clsx.default)(className, classes.space, fullWidth ? classes.fullWidth : '', fullHeight ? classes.fullHeight : '', paddingClassName),
    ref: forwardRef,
    "data-testid": dataTestId
  }, props), children);
});

/*
 * There is issues in currently used version of the storybook
 * related to default props and jss/styledComponents:
 * https://github.com/storybookjs/storybook/issues/8279
 * https://github.com/storybookjs/storybook/issues/8361
 *
 * The problem should be soloved in newer versions of storybook.
 * Temporary workaround - to wrap whole styled component in
 * another react component and then define prop-types on it.
 */
const Space = props => /*#__PURE__*/_react.default.createElement(StyledSpace, props);
Space.SIZE = _constants.SPACE_SIZE;
Space.defaultProps = {
  size: Space.SIZE.medium
};
var _default = exports.default = Space;